import request from '@/utils/request'
import { resolveApiBase } from '@/utils/apiBase'

export function getChangeOrderPage(params) {
  return request({
    url: '/api/change-order/page',
    method: 'get',
    params
  })
}

export function getChangeOrderDetail(id) {
  return request({
    url: `/api/change-order/${id}`,
    method: 'get'
  })
}

export function createChangeOrder(data) {
  return request({
    url: '/api/change-order',
    method: 'post',
    data
  })
}

export function approveChangeOrder(id) {
  return request({
    url: `/api/change-order/${id}/approve`,
    method: 'put'
  })
}

export function rejectChangeOrder(id) {
  return request({
    url: `/api/change-order/${id}/reject`,
    method: 'put'
  })
}

export function downloadChangeOrderUrl(id) {
  return `${resolveApiBase()}/api/change-order/${id}/download`
}
